import { api } from '@cwd/lib/main';
import { normalizeContactsResponse, type ContactsResponse } from '@views/Lists/ContactList.access';

export async function getAllContacts(skip = 0, pageSize = 25, extra = '', signal?: AbortSignal): Promise<ContactsResponse> {
    const raw = await api.get(`/Contacts/Full?$count=true&$skip=${skip}&$top=${pageSize}${extra}`, signal ? { signal } : undefined);
    return normalizeContactsResponse(raw);
}

export async function exportAllContactsExcel(extra: string): Promise<{ Url: string }> {
    return api.get(`/Contacts/Full?${extra}&$format=excel`);
}

export async function exportAllContactsCsv(extra: string): Promise<{ Url: string }> {
    return api.get(`/Contacts/Full?${extra}&$format=csv`);
}

export async function exportAllContactsToNewList(extra: string): Promise<{ ListId: string }> {
    return api.get(`/Contacts/Full?${extra}&$format=list`);
}

export async function exportAllContactsToExistingList(extra: string, targetListId: string): Promise<{ ListId: string }> {
    return api.get(`/Contacts/Full?${extra}&$format=addtolist&targetListId=${targetListId}`);
}

export async function exportAllContactsByMail(extra: string): Promise<void> {
    return api.get(`/Contacts/Full?${extra}&$format=excelmail`);
}
